import React from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import { Outlet } from "react-router-dom";
import {Container} from "react-bootstrap";

const Base = () =>{
  
       return(
           <div>
               <Header/>
               <main className="space-top-nav">
                   <Container fluid={'xxl'}>
                       <Outlet />
                   </Container>
               </main>
               <Footer/>
           </div>
      ); 
}

export default Base;